import { AgeCategory } from '../../../../../models/AgeCategory';

export interface ObjectType {
    currentKey: string | undefined;
    current: string | undefined;
    all: Record<string, any>;
}

interface ProductDetails {
    getDetails: (name: string) => ObjectType;
    fiction: ObjectType;
    productFormat?: ObjectType;
    ageCategory: ObjectType;
    ageGroup: any;
    explicit: ObjectType;
    getAgeGroups: (ageCategory: string | undefined) => string[];
}

export const productDetails: ProductDetails = {} as ProductDetails;

productDetails.fiction = {
    current: undefined,
    currentKey: undefined,
    all: {
        true: 'Fiction',
        false: 'Non-Fiction'
    }
};

productDetails.explicit = {
    current: undefined,
    currentKey: undefined,
    all: {
        true: 'Yes',
        false: 'No'
    }
};

productDetails.productFormat = {
    current: undefined,
    currentKey: undefined,
    all: {
        PDF: 'eBook (PDF)',
        EPUB: 'eBook (ePub)'
    }
};

productDetails.ageGroup = {
    current: undefined,
    currentKey: undefined,
    all: {
        '3+': '3+',
        '4+': '4+',
        '5+': '5+',
        '6+': '6+',
        '7+': '7+',
        '8+': '8+',
        '10+': '10+',
        '13+': '13+',
        '15+': '15+',
        All: 'All'
    }
};

productDetails.ageCategory = {
    current: undefined,
    currentKey: undefined,
    all: {
        Adult: 'Adult',
        'Young Adult': 'Young Adult',
        Children: 'Children'
    }
};

productDetails.getDetails = function (name: string) {
    return this[name];
};

productDetails.getAgeGroups = function (ageCategory) {
    switch (ageCategory) {
        case AgeCategory.YOUNG_ADULT:
            return ['13+', '15+', 'All'];
        case AgeCategory.CHILDREN:
            return ['3+', '4+', '5+', '6+', '7+', '8+', '10+', 'All'];
        default:
            return ['All'];
    }
};
